import { Box, Card, styled, useMediaQuery, useTheme } from '@mui/material';
import { H5 } from 'components/Typography';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  padding: '0px 0px',
  backgroundColor: theme.palette.primary.lightGrey200,
  borderRadius: 0,
  border: 'none',
  [theme.breakpoints.down('lg')]: {
    paddingLeft: '15px',
    paddingRight: '15px',
  },
}));

const TitleCard = ({ title = '최고 인기 사업', ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        paddingTop: isMobile ? '20px' : '30px',
        // paddingHorizontal: isMobile ? '15px' : '0px',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          overflow: 'visible',
        }}
      >
        <Box
          onClick={() => navigate('/naver/callmetellme/mypage')}
          sx={{
            cursor: 'pointer',
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexDirection="row"
          >
            <ChevronLeft
              size={isMobile ? 20 : 22}
              color={theme.palette.primary.greytxt}
              style={{ marginRight: isMobile ? '8px' : '12px' }}
            />
            <H5
              sx={{
                fontWeight: 'bold',
                lineHeight: 1.3,
                fontSize: isMobile ? '16px' : '18px',
              }}
            >
              {title}
            </H5>
          </Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default TitleCard;
